/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DataModelModule
 */

export const LIST_COLL_DATA_SOURCE_WITH_NAME_CONTAINS_SEARCH_PARAM =
    'ListCollDataSourceWithNameContainsSearchParam';
